import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

export default {
  methods: {
    currentDateTime() {
      return moment.utc().add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    },
    refresh() {
      this.refreshRaces();
    },
    refreshRaces() {
      let raceUrl = '';
      let loaddingmessage = '';
      let usemarketcount = 0;

      switch (this.$store.getters.screenConfig.mode) {
        case 'venue':
        case 'venuesmall': {
          loaddingmessage = 'Loading "Venue" Data';
          usemarketcount = this.$store.getters.screenConfig.venueMarketCount;

          break;
        }
        case 'nextthree': {
          loaddingmessage = 'Loading "Next Three" Data';
          usemarketcount = this.$store.getters.screenConfig.nextThreeMarketCount;

          break;
        }
        case 'four': {
          loaddingmessage = 'Loading "Multi-Screen" Data';
          usemarketcount = this.$store.getters.screenConfig.multiScreenMarketCount;

          break;
        }
      }

      this.$store.commit('updateIsLoading', true);
      this.$store.commit('updateScreenLoadingMessage', loaddingmessage);

      switch (this.$store.getters.screenConfig.mode) {
        case 'brand': {
          this.$store.commit('updateIsLoading', false);

          break;
        }
        case 'venue':
        case 'venuesmall':
        case 'nextthree':
        case 'four': {
          switch (this.$store.getters.screenConfig.mode) {
            case 'venuesmall':
            case 'venue': {
              raceUrl = `${this.$store.state.betManagerApiUrl}/rpc/refreshRaces/?dateCheck=${this.currentDateTime()}&bookieId=${this.$store.state.bookieId}&venueId=${this.$store.getters.screenConfig.venue}&scrreenMode=${this.$store.getters.screenConfig.mode}&screenName=${this.$store.getters.screenConfig.screenName}`;

              break;
            }
            case 'four':
            case 'nextthree': {
              raceUrl = `${this.$store.state.betManagerApiUrl}/rpc/refreshRaces/?dateCheck=${this.currentDateTime()}&bookieId=${this.$store.state.bookieId}&screenMode=${this.$store.getters.screenConfig.mode}&screenName=${this.$store.getters.screenConfig.screenName}`;

              break;
            }
          }

          axios.get(raceUrl, {
            headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
          })
            .then(response => {
              let screendata = response.data;
              let screendataindex = 0;

              screendata.forEach(bookieVenue => {
                screendataindex++;

                bookieVenue.index = screendataindex;
                bookieVenue.races = _.sortBy(bookieVenue.races, race => race.raceDateTime);

                bookieVenue.races.forEach((race, index) => {
                  race.index = index + 1;
                  race.markets = _.sortBy(race.markets, [this.$store.getters.screenConfig.sortBy]);

                  if (this.$store.getters.screenConfig.sortDirection === 'DESC') {
                    race.markets = race.markets.reverse();
                  }

                  if (this.$store.getters.screenConfig.sortBy === 'price') {
                    // If price sorting push scratched to bottom
                    const scratchedOrReservedrunners = _.remove(race.markets, (m) => {
                      return m.scratched === true || m.price === 0;
                    });

                    scratchedOrReservedrunners.forEach(scratchedRunner => {
                      race.markets.push(scratchedRunner);
                    });
                  }

                  race.markets.forEach((market, index) => {
                    market.oddsOn = market.price <= 1 && market.price !== 0;
                    market.include = (index + 1) < usemarketcount;
                  });

                  race.scrollMarkets = race.markets.filter(market => !market.include);
                });
              });

              this.$store.commit('updateScreenData', screendata);
              this.$store.commit('updateIsLoading', false);
              this.$store.commit('updateRefreshingPrice', false);
              this.$store.commit('updateScreenLoadingMessage', '');
            })
            .catch((error) => {
              console.log(error);
            });

          break;
        }
        case 'results': {
          let screendata = [];

          raceUrl = `${this.$store.state.betManagerApiUrl}/rpc/refreshRaces/?dateCheck=${this.currentDateTime()}&bookieId=${this.$store.state.bookieId}&screenMode=${this.$store.getters.screenConfig.mode}`;

          axios.get(raceUrl, {
            headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
          })
            .then(response => {
              const races = response.data;
              races.forEach((race, index) => {
                race.index = index;

                screendata.push(race);
              });

              this.$store.commit('updateScreenData', screendata);
              this.$store.commit('updateIsLoading', false);

            })
            .catch(error => {
              console.log(error);
            });

          break;
        }
      }
    }
  },
  computed: {
    races() {
      return this.$store.state.races;
    },
    primaryStyle() {
      return this.$store.getters.primaryStyle;
    },
    secondaryStyle() {
      return this.$store.getters.secondaryStyle;
    }
  },
  filters: {
    satime: function(value) {
      return moment.utc(value).format('HH:mm');
    },
    race(input) {
      if (input) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
      }

      return input;
    },
    venue(input) {
      if (input) {
        return input.replace('$VE ', '');
      }

      return input;
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/venuemixin.js